export default __webpack_public_path__ + "static/media/SurveyorText-Medium.ebc6e59e.woff";